/**
 * Created by robert.lavoie on 6/7/17.
 */

import { Component, Input } from '@angular/core';
import { Site } from 'careerpages-base/models/site';
import * as Raven from 'raven-js';

// Services
import { ServerResponseService } from '../../services/server-response.service';

/**
 *
 * @class
 * CustomerSitePageNotFoundComponent
 *
 * @description
 * This comonent shows 404 content when we have a customer site, but not the selected page
 * within the customer site
 *
 */
@Component({
  templateUrl: './customer-site-page-not-found.component.html',
  selector: 'customer-site-page-not-found',
  styleUrls: ['./customer-site-page-not-found.component.scss'],

})
export class CustomerSitePageNotFoundComponent {

  // The sites theme color
  @Input() themeColor: string;
  @Input() site: Site;

  constructor(private serverResponseService: ServerResponseService) {

    this.serverResponseService.setStatus(404);

    Raven.captureMessage('Customer Site 404', {
      level: 'info'
    });
  }
}
